<!--
 * @Description: 日期时间范围选择器（只能选择一天内的时间范围）
 * @Author: mdb
 * @Date: 2022-08-03 11:23:15
 * @LastEditTime: 2022-11-29 13:40:58
 * @LastEditors: mdb
-->
<template>
  <!-- 详情状态 -->
  <CosInputView v-bind="$attrs" :value="inputValue" v-if="view" />
  <!-- 新增、编辑状态 -->
  <a-input-group compact v-else>
    <a-date-picker
      v-model:value="dateValue"
      v-bind="$attrs"
      valueFormat="YYYY/MM/DD"
      style="width: 43%"
      @change="ok"
      :placeholder="props.placeholder"
    />
    <a-time-range-picker
      v-model:value="timeValue"
      v-bind="$attrs"
      :format="timeFormat"
      :valueFormat="timeFormat"
      style="width: 57%"
      @ok="ok"
    />
  </a-input-group>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import dayjs from 'dayjs'
import CosInputView from '@/components/Antd/CosView/input.vue'
import { Form } from 'ant-design-vue'
const props = defineProps({
  startTime: String,
  endTime: String,
  dataFormat: {
    type: String,
    default: 'YYYY/MM/DD'
  },
  dataRequired: {
    type: Boolean,
    default: true
  },
  view: {
    type: Boolean
  },
  placeholder: {
    type: String,
    default: '请选择日期'
  },
  timeRequired: {
    type: Boolean,
    default: true
  },
  timeFormat: {
    type: String,
    default: 'HH:mm'
  }
})
const formItemContext = Form.useInjectFormItemContext()
const dateValue = ref<string>()
const timeValue = ref<[string, string] | null>()
let startTimePage = ''
let endTimePage = ''
watch(
  () => [props.startTime, props.endTime],
  (v, prev) => {
    setTimeout(() => {
      const [startTime, endTime] = v
      if (startTime === startTimePage && endTime === endTimePage) {
        return
      }
      if (startTime || endTime) {
        dateValue.value = dayjs(startTime || endTime).format(props.dataFormat)
      } else {
        dateValue.value = ''
        timeValue.value = null
      }
      if (startTime && endTime) {
        const time: [string, string] = [
          dayjs(startTime).format(props.timeFormat),
          dayjs(endTime).format(props.timeFormat)
        ]
        timeValue.value = time
      }
    })
  }
)
const emit = defineEmits(['update:startTime', 'update:endTime', 'change'])
const ok = () => {
  let time1 = '00:00:00'
  let time2 = '00:00:00'
  let allTime
  const date = dayjs(dateValue.value).format(props.dataFormat)
  if (timeValue.value && timeValue.value.length) {
    time1 = timeValue.value[0] + ':00'
    time2 = timeValue.value[1] + ':00'
  }
  if (props.timeRequired && props.dataRequired) {
    if (!dateValue.value || !timeValue.value || !timeValue.value.length) {
      startTimePage = ''
      endTimePage = ''
      emit('update:startTime', '')
      emit('update:endTime', '')
      return
    }
  }
  startTimePage = date + ' ' + time1
  endTimePage = date + ' ' + time2
  emit('update:startTime', startTimePage)
  emit('update:endTime', endTimePage)
  emit('change')
  formItemContext.onFieldChange()
}

const inputValue = computed(() => {
  if (!props.view) return undefined
  try {
    if (props.startTime && props.endTime) {
      const date = props.startTime.split(' ')[0]
      const start = props.startTime.split(' ')[1]
      const end = props.endTime.split(' ')[1]
      return `${date} ${start}-${end}`
    } else {
      return undefined
    }
  } catch (error) {
    console.error(error)
    return undefined
  }
})
</script>
<script lang="ts">
export default { name: 'CosDateTimeRagePicker' }
</script>

<style></style>
